import { IWebsiteFont } from '../../../interfaces/Website/Banners/IWebsiteFont'

/**
 * A forma que a API gera (`Str::slug`: letras, números e hífen), e a que torna seguro usar o slug
 * cru na classe, no seletor e na whitelist do editor. Uma fonte fora dela é ignorada no painel.
 */
export const isSafeFontSlug = (slug: string) => /^[a-z0-9-]+$/.test(slug)

const CSS_FORMATS: Record<IWebsiteFont['format'], string> = {
  woff2: 'woff2',
  woff: 'woff',
  ttf: 'truetype',
  otf: 'opentype'
}

/** O `size-adjust` do `@font-face`, sempre um número — o valor vem da API e vai direto para o CSS. */
export const sizeAdjustOf = (font: Pick<IWebsiteFont, 'size_adjust'>) => Number(font.size_adjust) || 100

/** Nome da família no `@font-face`. O site usa o mesmo, então a prévia do painel é a do site. */
export const fontFamilyOf = (font: Pick<IWebsiteFont, 'slug'>) => `abra-font-${font.slug}`

/**
 * CSS das fontes enviadas: o `@font-face`, a classe que o editor escreve no trecho e o rótulo do
 * seletor, desenhado na própria fonte.
 *
 * Nome e URL entram como string JSON — as aspas e barras que vierem neles saem escapadas, e o CSS
 * vai por `textContent`, então nenhum dos dois consegue fechar a regra ou a tag.
 */
export function bannerFontCss(fonts: IWebsiteFont[]): string {
  return (
    fonts
      // O `useBannerFonts` já filtra; aqui é a garantia de quem chamar a função direto.
      .filter(({ slug }) => isSafeFontSlug(slug))
      .map((font) => {
        const family = JSON.stringify(fontFamilyOf(font))
        const picker = `.rich-text-field-banner .ql-snow .ql-picker.ql-bannerfont [data-value=${JSON.stringify(font.slug)}]::before`

        return [
          `@font-face { font-family: ${family}; src: url(${JSON.stringify(font.url)}) format('${CSS_FORMATS[font.format]}'); font-display: swap; size-adjust: ${sizeAdjustOf(font)}%; }`,
          `.ql-bannerfont-${font.slug} { font-family: ${family}, sans-serif; }`,
          `${picker} { content: ${JSON.stringify(font.name)}; font-family: ${family}, sans-serif; }`
        ].join('\n')
      })
      .join('\n')
  )
}
